import { createClient } from '@supabase/supabase-js';
import { DomainSecurity } from './utils/domainSecurity';
import { NetworkSecurity } from './utils/networkSecurity';

// Validate domain before creating client (fail secure)
if (!DomainSecurity.validateDomain()) {
  throw new Error('Unauthorized domain access');
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: {
    headers: {
      'X-Admin-Portal': 'true',
      'X-Client-Version': process.env.REACT_APP_VERSION || '1.0.0'
    }
  },
  auth: {
    // Custom auth settings for admin portal
    persistSession: true,
    detectSessionInUrl: true,
    autoRefreshToken: true
  }
});

// Initialize security measures
NetworkSecurity.initializeNetworkSecurity();